module.exports = __webpack_public_path__ + "static/media/loading-orange.1c077f52.svg";